import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IFileDownload } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.scss']
})
export class ComplaintsComponent implements OnInit {


  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Ticket ID',
      fieldName: 'complaintID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Candidate Number',
      fieldName: 'examNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination Schedule ID',
      fieldName: 'examinationScheduleID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Category ID',
      fieldName: 'categoryID',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Status',
      fieldName: 'status',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Closed Date',
      fieldName: 'closedDate',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Submitted Date',
      fieldName: 'submittedDate',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    }
  ];
  gridName = 'complaintGrid';
  constructor(private complaintService: ComplaintService, private snackBar: SnackbarService, private actRoute: ActivatedRoute, private eventService: EventService) { }

  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  async ngOnInit() {
    this.complaintService.setSelectedComplaints([]);

    this.actRoute.paramMap.subscribe(async params => {
      let examid = params.get("examid");
      let schid = params.get("examschid");
      if (examid) {
        this.data.tableParams.filterParams.push({
          fieldName: "examinationID",
          fieldValue: examid,
          queryOperand: 0,
          static: false
        });
      } else if (schid) {
        this.data.tableParams.filterParams.push({
          fieldName: "examinationScheduleID",
          fieldValue: schid,
          queryOperand: 0,
          static: false
        });
      }
      this.refreshData(this.data.tableParams);
    });

  }

  setComplaintData(complaintsIds: any[]) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.setComplaintData(complaintsIds), 50);
      return;
    }

    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedComplaints: any[] = complaintsIds.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedComplaints.map(x => x.id);

    GridUtil.setRowCliclk(this.gridName, complaintsIds, selectedDataRowsId);
    this.complaintService.setSelectedComplaints(selectedComplaints);
  }

  async refreshData(tableParams) {
    const res = await this.complaintService.getAllComplaints(tableParams) as any[];
    this.updateGridParams(res);
  }

}
